import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  BehaviorSubject,
  ReplaySubject,
  Subject,
  combineLatest,
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  first,
  from,
  map,
  mapTo,
  merge,
  of,
  pluck,
  retry,
  shareReplay,
  startWith,
  switchMap,
  takeUntil,
  tap,
  timer,
} from 'rxjs';
import { CustomProductAttributeConfig } from 'ZalamoLibrary/src/lib/ui/products/types';
import { parseProductConfigEntry } from 'ZalamoLibrary/src/lib/ui/products/products-front/helpers';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
} from '@angular/forms';
import {
  Product,
  ProductType,
} from '../../../../../../../../graphql/libs/product-editor/src/graphql';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import { ActivatedRoute } from '@angular/router';
import { RxjsOperators } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';
import { TypedFormBuilder } from '../../../form/TypedFormBuilder';
import { HttpClient } from '@angular/common/http';
import { GetAllProductsGQL } from 'ZalamoLibrary/src/lib/ui/products/product-editor/graphql';
import {
  buildRelationsMapForLookBook,
  calculateFiltersFromRelatedProducts,
  calculateProductsInPlay,
  filterAttributesByRelations,
  isOptionVisibleInRelatedProducts,
  RelationsMapForLookBook,
  shouldAttributeBeVisibleInRelatedProducts,
} from 'ZalamoLibrary/src/lib/ui/look-book-front/helpers';
import { environment } from 'ZalamoLibrary/src/lib/ui/look-book-front/enviroment/enviroment';
import { ProductUpdateDetails } from '../../../../../../../photographer-client/src/app/modules/look-book/types';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { FullscreenService } from 'ZalamoLibrary/src/lib/ui/fullscreen/fullscreen.service';
import {
  DecorationPreConfigForClient,
  GetDecorationDetailsForClientGQL,
  PriceConfig,
} from '../../../../../../../photographer-client/src/app/modules/look-book/graphql';
import cuid from 'cuid';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { LookBookOccasionForClient } from '../../../../../../../zalamo-embed/src/app/store/graphql';
import { BlobStorageService } from 'ZalamoLibrary/src/lib/upload/azure/azure';
import { DomSanitizer } from '@angular/platform-browser';
import { ImagesContainer } from 'ZalamoLibrary/src/lib/upload/graphql';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { PhotoGroupList } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';
import { EditWallDecorPieceComponent } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/edit-wall-decor-piece/edit-wall-decor-piece.component';
import { getPhotoGroupIdFromPhotoId } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/helpers';
import { LookBookPriceRounding } from '../../../../../../../photographer-panel/src/graphql';
import { SingleImageInWallDecorMap } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/types';

const cache = new Map();
const tokenCache = new Map();
const fileNameMap = new Map();
const SKETCH_ALBUM_NAME = 'album/sketch_full.jpg';
const SKETCH_TRIPLEX_NAME = 'triplex/sketch_full.jpg';
let isProxy = false;
type UseMap = { x1: number; x2: number; y1: number; y2: number }[];

@Component({
  selector: 'lib-look-book-album-preview',
  templateUrl: './look-book-album-preview.component.html',
  styleUrls: ['./look-book-album-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LookBookAlbumPreviewComponent
  extends AliveState
  implements OnInit
{
  futureProxy: LookBookAlbumPreviewComponent;
  @Input() imagesConfig = {};
  showOld$ = new BehaviorSubject(false);
  currentOptionName$ = new ReplaySubject(1);
  oldImageLoaded$ = new Subject();
  hasNextStep$ = new BehaviorSubject(true);
  filtered: Array<CustomProductAttributeConfig> = [];
  relationsMap: RelationsMapForLookBook;
  model = this.fb.group({});
  mappedValues$ = new BehaviorSubject(null);
  updateInProgress = false;
  @Output() updated = new EventEmitter<ProductUpdateDetails>();
  @Input() occasion: LookBookOccasionForClient;
  @Output() thumbUpdated = new EventEmitter();
  @Output() tokenUpdated = new EventEmitter();
  zalamoProductSet$ = new Subject();
  productsInPlay$ = new BehaviorSubject<Array<Product>>([]);
  productsInPlayForPrice$ = new BehaviorSubject<Array<Product>>([]);
  @Output() goToShoppingCart = new EventEmitter();
  @Input() @Required isInBasket = false;
  labsInPlay$ = new BehaviorSubject([]);
  labProductSet$ = new Subject();
  productsMap$ = new ReplaySubject<
    Record<string, Array<Product & { labId: string }>>
  >(1);
  currentImage$ = new ReplaySubject<string>(2);
  baseImage$ = new ReplaySubject<string>(1);
  sceneImages = [];
  $oldImage = new BehaviorSubject(null);
  $newImage = new BehaviorSubject(null);
  anyImage$ = merge(this.$oldImage, this.$newImage);

  @Input() context: ImagesContainer;
  @Input() contextId: ImagesContainer;
  @Input() availableImages: string[] = [];
  @Input() @Required imageRelations: PhotoGroupList[] = [];
  @Output() priceUpdated = new EventEmitter<PriceConfig[]>();
  showImage$ = this.model.valueChanges.pipe(
    map(
      (v) =>
        this.currentIndex !== 0 ||
        (v && v[this.item?.customId]) ||
        this.$newImage.value === SKETCH_ALBUM_NAME,
    ),
  );
  @Input() limitOptions = false;
  @Input() availableOptions = [];
  oldImageNotVisible$ = new BehaviorSubject(false);
  currentScene = new UntypedFormControl(0);
  odd = true;
  newImageLoaded$ = new Subject();
  size = new BehaviorSubject<{ width: number; height: number }>({
    width: null,
    height: null,
  });
  showPreloader$ = new BehaviorSubject(false);
  preloaderVisible$ = this.showPreloader$.pipe(
    switchMap((visible) =>
      visible ? timer(300).pipe(mapTo(visible)) : of(visible),
    ),
  );
  subConfig = new UntypedFormControl({
    firstName: 'Natalia',
    secondName: 'Daniel',
    date: '14.09.2022',
    connector: 'i',
    scene: '1',
    decorationId: null,
    mode: 'fromType',
    lines: [],
  });
  warnOpened = false;
  shouldUpdate$ = new Subject<Record<string, string | number | boolean>>();
  prevProductsInPlay = [];
  prevMappedValues: any = {};
  productType$ = new BehaviorSubject<ProductType>(null);

  imagesUpdated = new EventEmitter();

  images = new UntypedFormArray([]);
  imagesFormArrayUpdateInProgress = false;
  images$ = this.productType$.pipe(
    RxjsOperators.filterTruthy(),
    map((type) => {
      switch (type) {
        case ProductType.Triplex:
          return this.currentImageMap?.length
            ? this.currentImageMap
            : [null, null, null];
        case ProductType.AlbumWithAcrylicPicture:
          return [''];
        default:
          return [];
      }
    }),
    map((images) => {
      this.imagesFormArrayUpdateInProgress = true;
      while (this.images.length) {
        this.images.removeAt(0);
      }

      return images.map((image) => {
        this.images.push(new UntypedFormControl(image));
        return image;
      });
    }),
    tap(() => (this.imagesFormArrayUpdateInProgress = false)),
  );
  noDecoration$ = this.model.valueChanges.pipe(
    map(
      (v) =>
        v[this.decoration?.customId] ===
        this.decoration?.options.find(
          ({ decorationId }) => decorationId === null,
        )?.configId,
    ),
    shareReplay(1),
    startWith(
      this.model.value[this.decoration?.customId] ===
        this.decoration?.options.find(
          ({ decorationId }) => decorationId === null,
        )?.configId,
    ),
  );
  fromPreConfig$ = new BehaviorSubject(false);
  filteredUpdated$ = new Subject();
  currentConfigForImage = null;
  alreadySet = false;
  @ViewChild('calcDetails', { static: true }) calcDetails: TemplateRef<any>;
  @ViewChild('triplexSlots', { static: false }) triplexSlots: ElementRef<any>;
  @Input() forcedValues: Record<string, any> = {};
  isDev$ = this.activatedRoute.queryParams.pipe(
    pluck('isDev'),
    map((v) => !!v),
  );
  test = null;
  public isProxy = false;
  personalizationConfigSet = false;
  currentUseMap$ = new ReplaySubject<UseMap>(1);

  _personalizationPreConfig: DecorationPreConfigForClient = null;

  get personalizationPreConfig() {
    return this._personalizationPreConfig;
  }

  @Input() set personalizationPreConfig(
    personalizationPreConfig: DecorationPreConfigForClient,
  ) {
    this._personalizationPreConfig = personalizationPreConfig;
    this.subConfig.patchValue(personalizationPreConfig);
  }

  @Input() set productsMap(productsMap) {
    this.productsMap$.next(productsMap);
  }

  @Input() priceRounding: LookBookPriceRounding = null;

  @Input() set labsInPlay(labsInPlay: Array<string>) {
    if (labsInPlay) {
      this.labsInPlay$.next(labsInPlay);
    }
  }

  private _zalamoProduct: Product;

  get zalamoProduct(): Product {
    return this._zalamoProduct;
  }

  @Input() set zalamoProduct(value: Product) {
    if (!value) {
      return;
    }
    this.productType$.next(value.type);
    const config = JSON.parse(value.config) as CustomProductAttributeConfig[];

    this._zalamoProduct = { ...value, config: config as any };
    this.config = config;
    this.imagesConfig = JSON.parse(value.configurationImages);
    this.zalamoProductSet$.next(undefined);
  }

  private _labProduct: Product;

  get labProduct(): Product {
    return this._labProduct;
  }

  @Input() set labProduct(value: Product) {
    if (!value) {
      return;
    }
    this._labProduct = { ...value, config: JSON.parse(value.config) };
    this.labProductSet$.next(undefined);
  }

  get ratio() {
    const size = this.filtered.find(({ type }) => type === 'size');
    const currentSize = size.options.find(
      ({ configId }) => configId === this.model.value[size.customId],
    );
    return currentSize.width / currentSize.height;
  }

  get currentSize() {
    const size = this.filtered.find(({ type }) => type === 'size');

    const currentSize = size.options.find(
      (o) => o.configId === this.model.value[size.customId],
    );
    return `${Math.round(currentSize?.width / 10)}x${Math.round(
      currentSize?.height / 10,
    )}`.trim();
  }

  get item() {
    if (this._currentIndex === 2) {
      return this.filtered.find(({ type }) => type === 'decoration');
    }
    if (this._currentIndex === 3) {
      return {
        type: 'images',
        label: 'zdjęcia',
        customId: 'images',
        options: [],
      };
    }
    return this.filtered[this._currentIndex];
  }

  @Output() personalizationConfigUpdated = new EventEmitter();
  _decoration: CustomProductAttributeConfig = null;

  get decoration(): CustomProductAttributeConfig {
    return this.filtered.find(({ type }) => type === 'decoration');
  }

  get noDecorationOption() {
    return this.decoration.options.find(
      ({ decorationId }) => decorationId === null,
    );
  }

  @Output() hasPersonalizationChanged = new EventEmitter<boolean>();
  private _currentIndex = 0;

  get currentIndex(): number {
    return this._currentIndex;
  }
  @Output() closeMe = new EventEmitter();
  set currentIndex(value: number) {
    this._currentIndex = value;
    if (this.productType$.value === 'Triplex') {
      if (value === 2) {
        this.currentScene.patchValue(1);
      } else if (value === 3) {
        this.currentScene.patchValue(0);
      }
    }
    this.filter(false).pipe(first()).subscribe();
  }

  _config: Array<CustomProductAttributeConfig> = [];

  get config() {
    return this._config;
  }

  @Output() imagesChangedEvent = new EventEmitter<
    SingleImageInWallDecorMap[]
  >();

  @Input() set config(config: Array<CustomProductAttributeConfig>) {
    console.log(config);
    this._config = config;
    if (this._zalamoProduct && this._labProduct) {
      this.filter(true).pipe(first()).subscribe();
    }
  }

  currentImageMap = [];

  @Input() set imageMap(images) {
    images = [...images].map((v) =>
      v
        ? {
            ...v,
            pieceId: v.pieceId ? v.pieceId : v.wallDecorPieceId,
          }
        : null,
    );
    this.currentImageMap = images;
    this.images.patchValue(images);
  }

  @Input() set preConfig(preConfig) {
    if (!preConfig) {
      return;
    }
    const emptyModel = Object.keys(this.model.value).length === 0;
    const noEmptyValues = Object.values(
      typeof preConfig === 'string' ? JSON.parse(preConfig) : preConfig,
    ).filter((value) => typeof value === 'string' && value !== '').length;
    if (preConfig && emptyModel && noEmptyValues && !this.alreadySet) {
      this.alreadySet = true;
      this.fromPreConfig$.next(true);
      const config =
        typeof preConfig === 'string' ? JSON.parse(preConfig) : preConfig;
      Object.entries(config).forEach(([index, value]) =>
        this.model.addControl(index, new UntypedFormControl(value)),
      );

      console.log('SET PRECONFIG', preConfig);
    }
  }

  @Input() set personalizationConfig(preconfig) {
    if (preconfig && !this.personalizationConfigSet) {
      this.subConfig.patchValue(JSON.parse(preconfig));
      this.personalizationConfigSet = true;
    }
  }

  hasPersonalization = null;

  constructor(
    private fb: UntypedFormBuilder,
    public activatedRoute: ActivatedRoute,
    private form: TypedFormBuilder,
    private httpClient: HttpClient,
    private allProductsGQL: GetAllProductsGQL,
    private changeDetectorRef: ChangeDetectorRef,
    private zalamoDialogService: ZalamoDialogService,
    private fullscreenService: FullscreenService,
    private breakpointObserver: BreakpointObserver,
    private getDecorationDetailsForClientGQL: GetDecorationDetailsForClientGQL,
    private blobStorageService: BlobStorageService,
    private domSanitizer: DomSanitizer,
  ) {
    super();
    this.test = cuid();
    if (!isProxy) {
      isProxy = true;
      this.futureProxy = new LookBookAlbumPreviewComponent(
        fb,
        activatedRoute,
        form,
        httpClient,
        allProductsGQL,
        changeDetectorRef,
        zalamoDialogService,
        fullscreenService,
        breakpointObserver,
        getDecorationDetailsForClientGQL,
        blobStorageService,
        domSanitizer,
      );
      this.futureProxy.isProxy = true;
    }
  }

  showCalculationDetails() {
    this.zalamoDialogService.openFull(this.calcDetails);
  }

  imagesChanged(images: SingleImageInWallDecorMap[]) {
    console.log('IMAGE ');
    this.images.patchValue(images);
    // this.imagesChangedEvent.next(images);
  }

  ngOnInit(): void {
    this.currentOptionName$.next('Rozmiar');
    this.subscribeWhileAlive(
      // this.model.valueChanges.pipe(
      //   filter(() => !!this.decoration),
      //   tap((v) => {
      //     if (v[this.decoration.customId] === null) {
      //       v[this.decoration.customId] = this.decoration.options.find(
      //         ({ decorationId }) => decorationId === null
      //       ).configId;
      //       console.log('patching');
      //
      //       this.model.patchValue(v);
      //     }
      //   })
      // ),
      this.images.valueChanges.pipe(
        filter(() => !this.imagesFormArrayUpdateInProgress),
        tap((images) => this.imagesChangedEvent.next(images)),
      ),
      this.images$,
      this.model.valueChanges.pipe(tap(() => this.updateImage())),
      this.zalamoProductSet$.pipe(
        tap(() => {
          this.relationsMap = buildRelationsMapForLookBook(this.config);
        }),
      ),
    );

    const imagesInPlay = [];
    this.subscribeWhileAlive(
      this.subConfig.valueChanges.pipe(
        RxjsOperators.filterTruthy(),
        tap((x) => this.personalizationConfigUpdated.next(x)),
        tap(({ decorationId }) => {
          const update: Record<string, string> = {};
          if (decorationId === null) {
            if (this.decoration) {
              update[this.decoration.customId] = this.decoration.options.find(
                (option) => option.decorationId === null,
              )?.configId;
            }
          } else {
            if (this.decoration) {
              update[this.decoration.customId] = this.decoration.options.find(
                (option) => option.decorationId === decorationId,
              )?.configId;
            }
          }

          this.model.patchValue(update);
        }),
      ),
      combineLatest([
        this.shouldUpdate$,
        this.productsInPlay$.pipe(
          map((products) => products.map(({ productId }) => productId)),
        ),
        this.mappedValues$,
        this.subConfig.valueChanges.pipe(startWith(false)),
      ]).pipe(
        debounceTime(this.isProxy ? 0 : 500),
        tap(([config, productsInPlay, valueMap]) =>
          this.updated.emit({
            productsInPlay,
            config,
            valueMap,
            personalizationConfig: this.subConfig.value,
          }),
        ),
      ),
      merge(
        this.model.valueChanges,
        this.subConfig.valueChanges,
        this.currentScene.valueChanges,
        this.images.valueChanges,
      ).pipe(
        filter(
          () =>
            (this.config &&
              this.config[this._currentIndex] &&
              !!this.model.value[this.config[this._currentIndex].customId]) ||
            (this._currentIndex === 2 &&
              (this.subConfig.value?.decorationId ||
                this.productType$.value === ProductType.Triplex)) ||
            this.item?.type === 'images',
        ),
        filter(() => !this.isProxy),
        debounceTime(200),
        switchMap(() =>
          this.subConfig.value?.decorationId
            ? this.getDecorationDetailsForClientGQL
                .fetch({
                  variables: {
                    decorationId: this.subConfig.value?.decorationId,
                  },
                })
                .pipe(
                  pluck('data', 'getDecorationForClient', 'fields', 'length'),
                  map((v) => !!v),
                )
            : of(false),
        ),
        switchMap((hasPersonalization) => {
          if (this.hasPersonalization !== hasPersonalization) {
            this.hasPersonalizationChanged.next(hasPersonalization);
          }
          this.hasPersonalization = hasPersonalization;
          this.hasPersonalizationChanged.next(undefined);
          const body = {
            currentValue: {
              ...this.model.value,
            },
            productId: this.zalamoProduct.productId,
            currentConfigOptionId:
              2 === this._currentIndex
                ? this.filtered[this._currentIndex - 1].customId
                : this.filtered[this._currentIndex]?.customId,
            userDetails: {
              ...this.subConfig.value,
              firstNameInitial: this.subConfig.value?.firstName
                ? this.subConfig.value?.firstName[0]
                : '',
              secondNameInitial: this.subConfig.value?.secondName
                ? this.subConfig.value.secondName[0]
                : '',
            },
            scene: this.currentScene.value + 1,
            images: this.images.value.filter((v) => !!v),
          };
          if (this.currentIndex === 0) {
            body.currentValue[this.filtered[1].customId] = body.currentValue[
              this.filtered[1].customId
            ]
              ? body.currentValue[this.filtered[1].customId]
              : this.filtered[1].options[0].configId;
            body.currentConfigOptionId = this.filtered[1].customId;
          }
          if (typeof body.currentConfigOptionId === 'undefined') {
            if (this.item.type === 'images') {
              body.currentConfigOptionId = this.filtered[1].customId;
            }
          }
          if (!hasPersonalization) {
            if (body.userDetails.decorationId) {
              body.userDetails = {
                decorationId: body.userDetails.decorationId,
              };
            } else {
              delete body.userDetails;
            }
          }
          const parsed = JSON.stringify(body);
          console.log('HAS CACHE', cache.has(parsed));
          if (cache.has(parsed)) {
            if (fileNameMap.get(parsed)) {
              this.thumbUpdated.emit(fileNameMap.get(parsed));
              this.tokenUpdated.emit(tokenCache.get(parsed));
            }

            const url = cache.get(parsed);
            this.currentImage$.next(url);
            cache.set(JSON.stringify(body), url);
            this.showPreloader$.next(false);
            return of(null);
          }
          this.showPreloader$.next(true);
          console.log('GET IMAGE ', this.test, this.isProxy);
          return combineLatest([
            this.activatedRoute.queryParams.pipe(pluck('nocache')),
            this.productType$,
          ]).pipe(
            switchMap(([noCache, productType]) => {
              switch (productType) {
                case ProductType.Triplex:
                  return this.httpClient
                    .post<{ token: string; fileName: string }>(
                      `${environment.renderTriplex}${
                        noCache ? '?nocache=1' : ''
                      }`,
                      body,
                      {
                        responseType: 'json',
                        withCredentials: false,
                      },
                    )
                    .pipe(
                      filter((v) => !!v?.token),
                      retry(5),
                      switchMap((c) =>
                        from(
                          this.blobStorageService
                            .downloadFile(
                              {
                                storageUri:
                                  'https://newzalamomiddles.blob.core.windows.net',
                                storageAccessToken: c.token,
                                container: 'zalamo',
                                filename: null,
                              },
                              'zalamo',
                              c.fileName,
                            )

                            .then((r) => {
                              fileNameMap.set(parsed, c.fileName);
                              tokenCache.set(parsed, c.token);

                              this.thumbUpdated.next(c.fileName);
                              this.tokenUpdated.next(c.token);
                              return r.blobBody;
                            }),
                        ),
                      ),

                      // map((c) =>
                      //   this.domSanitizer.bypassSecurityTrustResourceUrl(
                      //     URL.createObjectURL(c)
                      //   )
                      // ),
                      tap(async (res) => {
                        // this.thumbUpdated.emit(res.headers.get('file-name'));
                        // fileNameMap.set(parsed, res.headers.get('file-name'));

                        const createImage = async (image: ImageBitmap) => {
                          const offscreen = new OffscreenCanvas(
                            image.width,
                            image.height,
                          );
                          offscreen.getContext('2d').drawImage(image, 0, 0);

                          return await offscreen
                            .convertToBlob()
                            .then((b) => URL.createObjectURL(b));
                        };
                        const scenes = await Promise.all([
                          createImageBitmap(res, 0, 0, 1920, 1080).then(
                            createImage,
                          ),
                          createImageBitmap(res, 0, 1080, 1920, 1080).then(
                            createImage,
                          ),
                          createImageBitmap(res, 0, 2160, 1920, 1080).then(
                            createImage,
                          ),
                        ]);
                        this.currentImage$.next(scenes[body.scene - 1]);
                        cache.set(
                          JSON.stringify({ ...body, scene: 1 }),
                          scenes[0],
                        );
                        cache.set(
                          JSON.stringify({ ...body, scene: 2 }),
                          scenes[1],
                        );
                        cache.set(
                          JSON.stringify({ ...body, scene: 3 }),
                          scenes[2],
                        );
                        this.showPreloader$.next(false);
                      }),
                    );

                default:
                  return this.httpClient
                    .post(
                      `${environment.renderUrl}${noCache ? '?nocache=1' : ''}`,
                      body,
                      {
                        responseType: 'blob',
                        observe: 'response',
                        withCredentials: false,
                      },
                    )
                    .pipe(
                      tap((res) => {
                        console.log(res.headers.get('file-name'));
                        this.thumbUpdated.emit(res.headers.get('file-name'));
                        fileNameMap.set(parsed, res.headers.get('file-name'));
                        const url = URL.createObjectURL(res.body);
                        this.currentImage$.next(url);
                        cache.set(parsed, url);
                        this.showPreloader$.next(false);
                      }),
                    );
              }
            }),
          );
        }),
      ),
      this.zalamoProductSet$.pipe(
        map(() => {
          const staticImages = [];
          this.config[0].options.forEach((option) => {
            console.log(option.label);

            this.config[1].options
              .filter((v, i) => i < 8)
              .forEach((option2, i) => {
                const config = {};
                config[this.config[0].customId] = option.configId;
                config[this.config[1].customId] = option2.configId;
                staticImages.push(config);
              });
          });
          return staticImages;
        }),
        // switchMap((staticImages) =>
        //   timer(0, 9000).pipe(
        //     switchMap((current) => {
        //       this.model.patchValue(
        //         staticImages[current % staticImages.length]
        //       );
        //       return timer(0, 3000).pipe(
        //         tap((v) => this.currentScene.patchValue(v))
        //       );
        //     })
        //   )
        // )
      ),
      this.currentImage$.pipe(
        tap((x) => console.log(x)),
        filter(
          (v) => this.currentIndex !== 2 || v.substr(0, 9) === 'blob:http',
        ),
        tap((currentImage) => {
          if (imagesInPlay.length === 0) {
            imagesInPlay.push(currentImage);
            this.$newImage.next(currentImage);
          } else {
            combineLatest([
              this.oldImageLoaded$,
              this.newImageLoaded$.pipe(delay(200)),
            ])
              .pipe(first())
              .subscribe(() => {
                this.showOld$.next(false);
              });
            if (!this.showOld$.value) {
              this.oldImageLoaded$.pipe(first()).subscribe(() => {
                this.$newImage.next(currentImage);
              });
            } else {
              this.$newImage.next(currentImage);
            }
            this.showOld$.next(true);
            this.$oldImage.next(imagesInPlay[0]);

            imagesInPlay[0] = currentImage;
            if (this.breakpointObserver.isMatched(Breakpoints.Handset)) {
              this.$newImage.next(currentImage);
            }
          }
        }),
      ),

      combineLatest([
        this.productsMap$.pipe(first()),
        this.zalamoProductSet$.pipe(first()),
        this.labsInPlay$.pipe(filter((v) => !!v.length)).pipe(first()),
        this.productsInPlay$.pipe(
          map((products) =>
            products
              .map(({ productId }) => productId)
              .sort()
              .join(),
          ),
          tap((x) => console.log(x)),
          distinctUntilChanged(),
        ),
        this.model.valueChanges.pipe(
          RxjsOperators.filterTruthy(),
          // tap((x) => console.log(x)),
          map((v) => JSON.stringify(v)),
          distinctUntilChanged(),
          startWith(true),
        ),
      ]).pipe(
        debounceTime(50),
        switchMap(() => this.filter()),
        tap(() => {
          combineLatest([this.productsMap$, this.labsInPlay$])
            .pipe(
              filter(() => !this.warnOpened),
              first(),
            )
            .subscribe(([productsMap, labsInPlay]) => {
              if (this.futureProxy) {
                this.futureProxy.config = this.config;
                this.futureProxy.forcedValues = this.forcedValues;
                this.futureProxy.labsInPlay = labsInPlay;
                this.futureProxy.limitOptions = this.limitOptions;
                this.futureProxy.availableOptions = this.availableOptions;
                this.futureProxy.productsMap = productsMap;
                this.futureProxy.zalamoProduct = {
                  ...this.zalamoProduct,
                  config: JSON.stringify(this.zalamoProduct.config),
                };
                this.futureProxy.currentIndex = this.currentIndex + 1;
                this.futureProxy.ngOnInit();
                this.futureProxy.model.patchValue(this.model.getRawValue());
                this.futureProxy
                  .filter()
                  .pipe(first())
                  .subscribe(() => {
                    const defaultedAttributes =
                      this.futureProxy.filtered.filter(
                        ({ type, customId, options }, index) =>
                          index < 2 &&
                          index >= this.currentIndex + 1 &&
                          ['list', 'size', 'decoration'].includes(type) &&
                          this.model.value[customId] &&
                          !options
                            .map(({ configId }) => configId)
                            .includes(this.model.value[customId]),
                      );
                    if (defaultedAttributes.length) {
                      this.warnOpened = true;
                      const ref = this.fullscreenService.open({
                        data: {
                          mode: 'warn',
                        },
                        content:
                          'Opcje ' +
                          defaultedAttributes
                            .map(({ label }) => label[0].text)
                            .join(', ') +
                          ' nie mogą zostać użyte w tej konfiguracji. Zostały przywrócone do wartości domyślnej ',
                      });
                      const defaults = defaultedAttributes.reduce(
                        (previousValue, currentValue) => {
                          previousValue[currentValue.customId] = null;
                          return previousValue;
                        },
                        {} as Record<string, any>,
                      );
                      this.model.patchValue(defaults);
                      ref.afterClosed$.pipe(first()).subscribe(() => {
                        this.warnOpened = false;
                      });
                    }
                  });
              }
            });
        }),
      ),
    );
    if (!this.fromPreConfig$.value) {
      this.productType$
        .pipe(RxjsOperators.filterTruthy(), first())
        .subscribe((v) => {
          switch (v) {
            case 'Album':
              this.currentImage$.next(SKETCH_ALBUM_NAME);
              break;
            case 'Triplex':
              this.currentImage$.next(SKETCH_TRIPLEX_NAME);
              break;
          }
        });
    }
  }

  filter(patch = false) {
    // if (!this.model.valid) {
    //   return;
    // }
    const that2 = this;
    let localProductsInPlay = [];
    return combineLatest([
      this.labsInPlay$,
      this.productsMap$.pipe(RxjsOperators.filterTruthy()),
    ]).pipe(
      first(),
      map(([labsInPlay, productsMap]) => {
        const currentValue = {
          ...this.model.getRawValue(),
          ...this.forcedValues,
        };

        const { mappedValues, productsInPlay } = calculateProductsInPlay(
          labsInPlay,
          productsMap,
          currentValue,
          this.filtered,
          this.relationsMap,
          this.currentIndex,
        );
        const productsMapObjects = new Map<
          Product & { labId: string },
          number
        >();

        Object.keys(currentValue)
          .filter((value, index) => index >= this.currentIndex)
          .forEach((index) => (currentValue[index] = ''));
        const prevLevel = calculateProductsInPlay(
          labsInPlay,
          productsMap,
          { ...currentValue, ...this.forcedValues },
          this.filtered,
          this.relationsMap,
          this.currentIndex,
          true,
        );
        this.prevMappedValues = prevLevel.mappedValues;
        this.prevProductsInPlay = prevLevel.productsInPlay;
        this.mappedValues$.next({ ...mappedValues });

        localProductsInPlay = productsInPlay;
        return null;
      }),
      map(() => {
        let filtered: Array<CustomProductAttributeConfig> = [];
        const currentValue = { ...this.model.getRawValue() };
        if (this.config) {
          console.log(this.model.value);
          this.updateInProgress = true;
          if (currentValue && Object.keys(currentValue).length) {
            this.shouldUpdate$.next(
              parseProductConfigEntry(
                [...this.config],
                this.model,
                { ...currentValue },
                filtered,
                true,
                false,
                true,
              ),
            );
          } else {
            parseProductConfigEntry(
              [...this.config],
              this.model,
              { ...currentValue },
              filtered,
              true,
              false,
              true,
            );
          }

          this.updateInProgress = false;
        }
        filtered = filtered.filter(({ active }) => active);
        this.filteredUpdated$.next(undefined);
        const productsToRemove = [];
        const mappedValues = { ...this.mappedValues$.value };

        const filtersFromRelatedProducts = calculateFiltersFromRelatedProducts(
          localProductsInPlay,
          mappedValues,
          currentValue,
          productsToRemove,
        );
        const filterForPrevLevel = calculateFiltersFromRelatedProducts(
          this.prevProductsInPlay,
          this.prevMappedValues,
          currentValue,
          [],
        );
        combineLatest([this.productsMap$, this.labsInPlay$])
          .pipe(first())
          .subscribe(([productsMap, labsInPlay]) => {
            const forPrice = calculateProductsInPlay(
              labsInPlay,
              productsMap,
              { ...currentValue, ...this.forcedValues },
              this.filtered,
              this.relationsMap,
              Object.keys(currentValue).length - 1,
            );
            this.productsInPlayForPrice$.next(forPrice.productsInPlay);
          });

        if (productsToRemove.length) {
          const toRemove = [...new Set(productsToRemove)];

          this.prevProductsInPlay = [...localProductsInPlay];
          this.productsInPlay$.next(
            localProductsInPlay.filter(
              ({ productId }) => !toRemove.includes(productId),
            ),
          );
          this.productsInPlayForPrice$.next(
            this.productsInPlayForPrice$.value.filter(
              ({ productId }) => !toRemove.includes(productId),
            ),
          );
        } else {
          console.log(
            this.productsInPlay$.value.map(({ productId }) => productId),
            ' VS ',
            localProductsInPlay.map(({ productId }) => productId),
          );

          this.productsInPlay$.next(localProductsInPlay);
        }

        filterAttributesByRelations(
          filtered,
          this.relationsMap,
          filterForPrevLevel,
          filtersFromRelatedProducts,
          this.currentIndex,
        );
        if (patch) {
          this.model.patchValue(currentValue);
        }

        if (JSON.stringify(this.filtered) !== JSON.stringify(filtered)) {
          this.filtered = filtered;

          this.model.patchValue(currentValue);

          console.log('UPDATE FILTERED');
        }
        const that = this;
        return null;
      }),
    );
  }

  updateImage() {
    const currentElementId = this.config[this._currentIndex]?.customId;
    if (!!this.imagesConfig[currentElementId]) {
      const matchingConfig = this.imagesConfig[currentElementId].find(
        (config) => {
          for (const id in config.config) {
            const value = Array.isArray(config.config[id].value)
              ? config.config[id].value[0]
              : config.config[id].value;
            if (this.model.value[id] !== value) {
              return false;
            }
          }
          return true;
        },
      );
      if (matchingConfig && matchingConfig.fileName) {
        this.odd = !this.odd;
        // this.currentImage$.next(matchingConfig.fileName);
        this.sceneImages = [matchingConfig.fileName];
        if (matchingConfig.fileName2) {
          this.sceneImages.push(matchingConfig.fileName2);
        }
        if (matchingConfig.fileName3) {
          this.sceneImages.push(matchingConfig.fileName3);
        }
      }
    }
  }

  openTriplexPhotoPicker(currentIndex) {
    const ref = this.zalamoDialogService.openRight(EditWallDecorPieceComponent);
    ref.componentInstance.availableImages = this.availableImages;
    ref.componentInstance.imageRelations = this.imageRelations;
    ref.componentInstance.photoId = this.images.value[currentIndex]?.photoId;
    ref.componentInstance.currentCrop.patchValue(
      this.images.value[currentIndex]?.crop,
    );

    ref.componentInstance.ratio = this.ratio;

    ref.componentInstance.saved
      .pipe(
        tap(({ photoId, crop }) => {
          console.log([
            ...(this.images.value ?? []).filter(
              (v) => v?.pieceId !== currentIndex,
            ),
            {
              photoId,
              pieceId: currentIndex,
              photoGroupId: getPhotoGroupIdFromPhotoId(
                photoId,
                this.imageRelations,
              ),
              crop,
            },
          ]);
          const current = this.images.value ? [...this.images.value] : [];
          current[currentIndex] = {
            photoId,
            pieceId: currentIndex,
            photoGroupId: getPhotoGroupIdFromPhotoId(
              photoId,
              this.imageRelations,
            ),
            crop,
            isFlip: false,
          };
          this.images.patchValue(current);

          ref.close();
        }),
        takeUntil(ref.afterClosed()),
      )
      .subscribe();
  }

  imageLoaded({ target }: { target: HTMLElement }) {
    const defaults: Record<string, Record<number, UseMap>> = {
      '15x15': {
        0: [
          { x1: 670, y1: 463, x2: 830, y2: 670 },
          { x1: 880, y1: 463, x2: 1058, y2: 670 },
          { x1: 1105, y1: 463, x2: 1270, y2: 670 },
        ],
        2: [
          { x1: 586, y1: 463, x2: 813, y2: 606 },
          { x1: 861, y1: 463, x2: 1065, y2: 606 },
          { x1: 1106, y1: 463, x2: 1330, y2: 606 },
        ],
      },
      '15x23': {
        0: [
          { x1: 633, y1: 334, x2: 813, y2: 670 },
          { x1: 853, y1: 334, x2: 1072, y2: 670 },
          { x1: 1105, y1: 334, x2: 1289, y2: 670 },
        ],
        2: [
          { x1: 525, y1: 408, x2: 807, y2: 632 },
          { x1: 832, y1: 408, x2: 1087, y2: 632 },
          { x1: 1110, y1: 408, x2: 1387, y2: 632 },
        ],
      },
      '20x20': {
        0: [
          { x1: 590, x2: 780, y1: 390, y2: 673 },
          { x1: 850, x2: 1100, y1: 390, y2: 673 },
          { x1: 1144, x2: 1350, y1: 390, y2: 673 },
        ],
        2: [
          { x1: 456, x2: 774, y1: 444, y2: 638 },
          { x1: 817, x2: 1108, y1: 444, y2: 638 },
          { x1: 1145, x2: 1460, y1: 444, y2: 638 },
        ],
      },
      '20x30': {
        0: [
          { x1: 590, x2: 795, y1: 237, y2: 670 },
          { x1: 840, x2: 1100, y1: 237, y2: 670 },
          { x1: 1140, x2: 1350, y1: 237, y2: 670 },
        ],
        2: [
          { x1: 435, x2: 774, y1: 400, y2: 690 },
          { x1: 810, x2: 1108, y1: 400, y2: 690 },
          { x1: 1145, x2: 1475, y1: 400, y2: 690 },
        ],
      },
    };
    if (!defaults[this.currentSize]) {
      return;
    }
    const imageMap: UseMap =
      defaults[this.currentSize][this.currentScene.value];
    if (!imageMap) {
      return;
    }
    const imageSize = target.getBoundingClientRect();
    const containerSize = target.parentElement.getBoundingClientRect();
    const imageTargetRatio = 1920 / 1080;
    let targetWidth = 1920;
    let targetHeight = 1080;
    if (window.innerWidth / window.innerHeight > 17 / 11) {
      const targetScale = Math.max(
        imageSize.width / 1920,
        imageSize.height / 1080,
      );
      this.triplexSlots.nativeElement.style.transform = `scale(${targetScale})`;
      this.triplexSlots.nativeElement.style.top = `${Math.min(
        0,
        (containerSize.height - targetScale * 1080) / 2,
      )}px`;
      this.triplexSlots.nativeElement.style.left = `calc(50% - ${
        this.triplexSlots.nativeElement.getBoundingClientRect().width / 2
      }px)`;
    } else {
      if (containerSize.width / containerSize.height > imageTargetRatio) {
        targetWidth = containerSize.height * imageTargetRatio;
        targetHeight = containerSize.height;
        this.triplexSlots.nativeElement.style.left = `${
          (containerSize.width - targetWidth) / 2
        }px`;
        this.triplexSlots.nativeElement.style.top = `0px`;
        this.triplexSlots.nativeElement.style.transform = `scale(${
          imageSize.height / 1080
        })`;
      } else {
        targetWidth = containerSize.width;
        targetHeight = targetWidth * (imageSize.width / 1920);
        this.triplexSlots.nativeElement.style.left = `0px`;

        this.triplexSlots.nativeElement.style.transform = `scale(${
          imageSize.width / 1920
        })`;
        console.log(
          `calc(50% - ${
            this.triplexSlots.nativeElement.getBoundingClientRect.height / 2
          }px)`,
        );
        this.triplexSlots.nativeElement.style.top = `calc(50% - ${
          this.triplexSlots.nativeElement.getBoundingClientRect().height / 2
        }px)`;
      }
    }

    console.log(targetWidth, targetHeight);
    this.currentUseMap$.next(imageMap);
  }

  protected readonly close = close;
}
